import * as React from 'react';
import { EDTextEdit } from '../../../../BaseComponents/TextEdit/EDTextEdit';

interface IProps {
  value: string;
  onChange: (newValue: string) => void;
}

/**
 * Ett sökfält med bakgrundsfärg och titel. Används typiskt för att filtrera listor.
 */
export const SearchBar: React.FC<React.PropsWithChildren<IProps>> = props => {
  return (
    <EDTextEdit
      allMargins="none"
      fullWidth
      value={props.value}
      onChange={props.onChange}
      label="Sök"
      autoFocus
    />
  );
};

export default SearchBar;
